import React from 'react';
import { Target, Calendar, Users, CheckSquare } from 'lucide-react';
import clsx from 'clsx';

interface ScopingStatsProps {
    isDark: boolean;
    completedTasks: number;
    totalTasks: number;
    completedMilestones: number;
    totalMilestones: number;
    teamSize: number;
    goalCount: number;
}

const StatCard = ({ icon: Icon, color, label, value, subtext, isDark }: any) => (
    <div className={clsx('p-4 rounded-lg border', isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200')}>
        <div className="flex items-center gap-2 mb-2"><Icon size={16} className={color} /><span className="text-sm text-slate-500">{label}</span></div>
        <div className={clsx('text-2xl font-bold', isDark ? 'text-white' : 'text-slate-800')}>{value}</div>
        <div className="text-xs text-slate-500">{subtext}</div>
    </div>
);

export const ScopingStats: React.FC<ScopingStatsProps> = ({ isDark, completedTasks, totalTasks, completedMilestones, totalMilestones, teamSize, goalCount }) => (
    <div className="px-4 py-4 grid grid-cols-4 gap-4">
        <StatCard icon={CheckSquare} color="text-green-500" label="Tasks Progress" value={`${completedTasks}/${totalTasks}`} subtext={`${Math.round((completedTasks / (totalTasks || 1)) * 100)}% complete`} isDark={isDark} />
        <StatCard icon={Calendar} color="text-blue-500" label="Milestones" value={`${completedMilestones}/${totalMilestones}`} subtext={`${Math.round((completedMilestones / (totalMilestones || 1)) * 100)}% complete`} isDark={isDark} />
        <StatCard icon={Users} color="text-orange-500" label="Team Members" value={teamSize} subtext="Cross-functional" isDark={isDark} />
        <StatCard icon={Target} color="text-purple-500" label="Goals" value={goalCount} subtext="Defined" isDark={isDark} />
    </div>
);
